module.exports = __webpack_public_path__ + "img/horizontal_4_7_6005.00b2afff.png";